import React from "react";
import "../styles/productEducation.css";

function SettingsToggle({ label, hint, checked, onChange, disabled = false }) {
  return (
    <label
      className={`pep-settings__row${disabled ? " pep-settings__row--disabled" : ""}`}
    >
      <span>
        <span className="pep-settings__label">{label}</span>
        {hint ? <p className="pep-settings__hint">{hint}</p> : null}
      </span>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
    </label>
  );
}

export function ProductEducationSettingsScreen({
  settings,
  onUpdateSettings,
  onReplayLatestRelease,
  onReplayAshleyBriefing,
  onOpenWhatsNew,
  onReplayFirstTimeOnboarding,
}) {
  return (
    <div className="pep-settings">
      <div className="pep-settings__group">
        <h3 className="pep-settings__heading">Automatic education</h3>
        <SettingsToggle
          label="Auto-launch release education"
          hint="Off by default. When enabled, show release overviews after you update to a new version."
          checked={settings.autoTourEnabled}
          onChange={(value) => onUpdateSettings({ autoTourEnabled: value })}
        />
        <SettingsToggle
          label="Ashley release brief"
          hint="Off by default. When enabled with auto-launch, start with Ashley's welcome summary before optional tours."
          checked={settings.ashleyBriefEnabled}
          onChange={(value) => onUpdateSettings({ ashleyBriefEnabled: value })}
        />
        <SettingsToggle
          label="Always show What's New"
          hint="Keep a dashboard reminder until you open What's New."
          checked={settings.alwaysShowWhatsNew}
          onChange={(value) => onUpdateSettings({ alwaysShowWhatsNew: value })}
        />
        <SettingsToggle
          label="Ashley narration"
          hint="Available in a future release."
          checked={settings.ashleyNarrationEnabled}
          onChange={(value) => onUpdateSettings({ ashleyNarrationEnabled: value })}
          disabled
        />
        <SettingsToggle
          label="Prefer summaries"
          hint="Default to Just Tell Me when a new release is detected."
          checked={settings.preferSummaries}
          onChange={(value) => onUpdateSettings({ preferSummaries: value })}
        />
        <SettingsToggle
          label="Disable automatic first-time onboarding"
          hint="Legacy dashboard guide auto-start is off by default. Turn this off only if you want first-time auto-launch restored."
          checked={!settings.autoFirstTimeGuideEnabled}
          onChange={(value) =>
            onUpdateSettings({ autoFirstTimeGuideEnabled: !value })
          }
        />
      </div>

      <div className="pep-settings__group">
        <h3 className="pep-settings__heading">Replay &amp; history</h3>
        <div className="pep-panel__actions" style={{ padding: 0 }}>
          <button
            type="button"
            className="pep-btn pep-btn--secondary pep-launcher-menu__item"
            onClick={onReplayLatestRelease}
          >
            Replay latest release briefing
          </button>
          <button
            type="button"
            className="pep-btn pep-btn--secondary pep-launcher-menu__item"
            onClick={onReplayAshleyBriefing}
          >
            Replay Ashley briefing
          </button>
          <button
            type="button"
            className="pep-btn pep-btn--secondary pep-launcher-menu__item"
            onClick={onOpenWhatsNew}
          >
            Open What&apos;s New
          </button>
          <button
            type="button"
            className="pep-btn pep-btn--secondary pep-launcher-menu__item"
            disabled
            onClick={onReplayFirstTimeOnboarding}
          >
            Replay first-time onboarding (coming soon)
          </button>
        </div>
      </div>
    </div>
  );
}
